var _tspan, _tspan2, _tspan3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProviderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Calque-1",
    serifId: "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0215,0,0,1,-9.53222,0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "443.359px",
    y: "573px",
    style: {
      fontFamily: "'Nexa'",
      fontSize: 41,
      fill: "white"
    }
  }, "P", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "470.741px 494.559px 528.176px ",
    y: "573px 573px 573px "
  }, "owe")), "r")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0215,0,0,1,-12.2887,0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "571.566px",
    y: "573px",
    style: {
      fontFamily: "'Nexa'",
      fontSize: 41,
      fill: "white"
    }
  }, "e")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0215,0,0,1,-12.8163,0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "596.109px",
    y: "573px",
    style: {
      fontFamily: "'Nexa'",
      fontSize: 41,
      fill: "white"
    }
  }, "d")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0215,0,0,1,-13.6181,0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "633.402px",
    y: "573px",
    style: {
      fontFamily: "'Nexa'",
      fontSize: 41,
      fill: "white"
    }
  }, "b", _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: "658.536px ",
    y: "573px "
  }, "y")))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0215,0,0,1,-14.8716,0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "691.703px",
    y: "573px",
    style: {
      fontFamily: "'Nexa'",
      fontSize: 41,
      fill: "white"
    }
  }, "L", _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: "712.051px 734.583px 751.349px ",
    y: "573px 573px 573px "
  }, "yra"))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,-0,644.686,330.97)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -18.09,
    y: -0.18,
    width: 17.91,
    height: 18.27,
    style: {
      fill: "rgb(54,117,186)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,778,526.613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-195.463L-102.332,-195.463L-102.332,-177.552L-17.913,-177.553L-17.913,-17.911L-316.729,-17.911L-316.729,-177.552L-151.403,-177.552L-151.403,-195.463L-334.642,-195.463L-334.642,0L0,0L0,-195.463Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,578.846,500.983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-113.78L1.92,-122.812L-76.468,-122.812L-80.308,-104.748L-29.895,-104.748L-97.104,-31.906L-99.458,-20.833L-19.759,-20.834L-15.888,-39.044L-68.778,-39.044L0,-113.78ZM-178.857,-61.188L-186.288,-41.375L-193.137,-61.625L-204.065,-92.655L-224.754,-92.655L-196.05,-21.999L-209.455,9.177L-189.931,9.177L-146.075,-92.655L-165.745,-92.655L-178.857,-61.188ZM132.71,-93.821C123.676,-93.821 115.617,-90.179 106.814,-83.041L107.724,-92.801L91.842,-92.801L76.543,-20.834L94.173,-20.834L101.977,-57.546C104.3,-68.473 113.682,-77.65 124.61,-77.65C135.975,-77.65 140.183,-69.346 137.859,-58.421L129.87,-20.834L147.646,-20.834L155.667,-58.565C160.467,-81.146 149.611,-93.821 132.71,-93.821M16.899,-65.121C21.503,-74.445 30.362,-79.108 39.978,-79.108C50.178,-79.108 56.471,-74.446 55.655,-65.121L16.899,-65.121ZM42.741,-94.841C19.428,-94.841 1.222,-79.108 -3.424,-57.254C-8.317,-34.236 3.148,-18.94 27.917,-18.94C38.845,-18.94 52.034,-22.728 61.283,-30.595L52.303,-41.813C47.325,-37.588 38.203,-35.111 31.645,-35.111C19.115,-35.111 12.756,-41.521 13.48,-50.408L69.574,-50.408C78.63,-79.981 66.781,-94.841 42.741,-94.841M-353.764,-68.472L-382.613,-68.472L-382.613,-104.6L-353.764,-104.6C-329.287,-104.6 -329.14,-68.472 -353.764,-68.472M-353.764,-122.957C-369.791,-122.957 -385.819,-122.812 -401.846,-122.812L-401.846,-20.833L-382.613,-20.833L-382.613,-50.844L-353.764,-50.844C-303.788,-50.844 -303.934,-122.957 -353.764,-122.957M-272.611,-34.965C-284.413,-34.965 -293.884,-43.123 -293.884,-56.817C-293.884,-70.511 -284.413,-78.523 -272.611,-78.524C-244.636,-78.524 -244.636,-34.965 -272.611,-34.965M-251.338,-82.749C-255.419,-89.887 -264.597,-94.404 -274.214,-94.404C-295.194,-94.548 -311.659,-81.583 -311.659,-56.817C-311.659,-31.614 -295.924,-18.503 -274.651,-18.649C-266.637,-18.794 -255.419,-22.873 -251.338,-31.322L-250.464,-20.833L-233.708,-20.833L-233.708,-92.655L-250.756,-92.655L-251.338,-82.749Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderLogo);
export default __webpack_public_path__ + "static/media/provider-logo.45fc3987ca077c4c8943f7df8405375d.svg";
export { ForwardRef as ReactComponent };